/** One workspace page for measured savings, the cut, government schemes, and credit trading. */
export const CARBON_SAVINGS_TRADING_PATH = '/carbon-savings';

export const CARBON_SAVINGS_TRADING_SECTIONS = [
  { id: 'savings', label: 'Savings', path: '/carbon-savings?section=savings' },
  { id: 'cut', label: 'Target', path: '/carbon-savings?section=cut' },
  { id: 'schemes', label: 'Government schemes', path: '/carbon-savings?section=schemes' },
  { id: 'trading', label: 'Offsets and credits', path: '/carbon-savings?section=trading' },
] as const;

export type CarbonSavingsTradingSectionId = (typeof CARBON_SAVINGS_TRADING_SECTIONS)[number]['id'];

const TRADING_TABS = new Set(['0', '1', '2', '3']);

export function carbonSavingsTradingSection(search: string): CarbonSavingsTradingSectionId {
  const raw = new URLSearchParams(search).get('section');
  const match = CARBON_SAVINGS_TRADING_SECTIONS.find((section) => section.id === raw);
  return match?.id ?? 'savings';
}

/** Old goal and marketplace URLs land on the matching section of the combined page. */
export function legacyCarbonSavingsTradingTarget(pathname: string, search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const tab = params.get('tab');

  if (pathname === '/emissions-reduction-targets' || pathname.startsWith('/emissions-reduction-targets/')) {
    if (tab === '2') {
      return `${CARBON_SAVINGS_TRADING_PATH}?section=schemes`;
    }
    const inner = tab === '1' ? '1' : '0';
    return `${CARBON_SAVINGS_TRADING_PATH}?section=cut&tab=${inner}`;
  }

  const isTrading = pathname === '/carbon-marketplace'
    || pathname.startsWith('/carbon-credits')
    || pathname.startsWith('/carbon-trading');
  if (!isTrading) {
    return null;
  }

  const next = new URLSearchParams();
  next.set('section', 'trading');
  if (tab && TRADING_TABS.has(tab)) {
    next.set('tab', tab);
  }
  params.forEach((value, key) => {
    if (key !== 'tab' && key !== 'section') {
      next.set(key, value);
    }
  });
  return `${CARBON_SAVINGS_TRADING_PATH}?${next.toString()}`;
}
